import { useContext, useCallback } from 'react';
import _get from 'lodash/get';
import _find from 'lodash/find';
import { AjaxContext, AppContext, formatListData, EMPTY_ARRAY, UserContext } from 'commons-ui';
import { UserDetailsContext } from 'context/userDetails';
import { ACTION, PAGE_NAMES, USER_PROFILE_RESOURCES } from 'constant';

const useService = () => {
	const {
		app: { appName }
	} = useContext(AppContext);
	const { postData } = useContext(AjaxContext);
	const {
		selectedUser: { uid }
	} = useContext(UserDetailsContext);
	const { permissionsConfig } = useContext(UserContext);
	const listKycDocumentsHistory = useCallback(async () => {
		const permission = _find(permissionsConfig, { actionName: ACTION.listKycDocumentsHistory });
		const result = await postData({
			endpoint: `/dashboard/listKycDocumentsHistory/${PAGE_NAMES.userProfile}-${USER_PROFILE_RESOURCES.kycDetails}-listKycDocumentsHistory`,
			queryParams: {
				appName
			},
			body: { zupeeUserId: uid },
			customHeaders: {
				isMasked: permission?.isMasked || false
			}
		});
		const data = _get(result, ['data', 'data'], EMPTY_ARRAY);
		const listData = formatListData(data);

		return { rowCount: listData.length, data: listData };
	}, []);

	return { listKycDocumentsHistory };
};

export default useService;
